import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from 'src/app/core/services/utils.service';

@Component({
  selector: 'app-cookies-popup-in',
  templateUrl: './cookies-popup-in.component.html',
  styleUrls: ['./cookies-popup-in.component.scss']
})
export class CookiesPopupInComponent implements OnInit {

  stylesheetString = "aft";

  constructor(public dialogRef: MatDialogRef<CookiesPopupInComponent>, private utilsService: UtilsService) { }
  ngOnInit(): void {
    this.stylesheetString = this.utilsService.getStylesheetString();
  }

  close(): void {
    this.dialogRef.close();
  }

}
